<template>
    <hts-drawer
        v-model="visible"
        :submit="handleSubmit"
        :rules="rulesAddNodeType"
        :title="$t('labels.nodeTypeModule.add')"
        @close="visible = false">
        <div class="hts-vehicles-ignore-add-vehicle">
            <div class="hts-vehicles-ignore-add-vehicle__container-body">
                <hts-card :title="$t('labels.generalInformation')">
                    <hts-form-select
                        ref="selectTypeName"
                        v-model="dataAdd.name"
                        :items="nodeTypeNames"
                        :filterable="true"
                        :clearable="true"
                        :label="$t('labels.nodeTypeModule.name')"
                        required
                        name="nodeTypeModule.name"
                        prop="nodeTypeModule.name"
                        key-id="value"
                        key-label="value"
                        creatable
                        @create-new="handleCreateNewNodeType" />

                    <hts-form-input
                        v-model="dataAdd.description"
                        :label="$t('labels.description')"
                        :color="props.color"
                        name="description"
                        prop="description" />

                    <hts-admincp-select-business
                        v-model="dataAdd.businesses"
                        :filterable="true"
                        :clearable="true"
                        :label="$t('labels.business')"
                        required
                        multiple
                        name="business"
                        prop="business"
                        key-tooltip="tasksName" />
                </hts-card>
            </div>
        </div>
        <hts-modal v-model="addNewNodeTypeName">
            <template #custom>
                <hts-card
                    :title="$t('labels.nodeTypeName')"
                    class="mt-5">
                    <hts-form-input v-model="newNodeTypeName" />
                </hts-card>
                <div class="flex mt-5 justify-end">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        color="primary"
                        type="submit"
                        :loading="false"
                        :disabled="!newNodeTypeName"
                        @click="createNewNodeType">
                        {{ $t('labels.save') }}
                    </hts-form-button>

                    <hts-form-button
                        class="pl-2"
                        icon-name="hi-x-mark-icon"
                        icon-position="right"
                        color="error"
                        @click="addNewNodeTypeName = false">
                        {{ $t('labels.cancel') }}
                    </hts-form-button>
                </div>
            </template>
        </hts-modal>
    </hts-drawer>
</template>
<script setup lang="ts">
import { rulesAddNodeType } from '../imports/model'
import { initNodeTypeNames } from '../imports/utils'

const nodeTypeNames = ref(initNodeTypeNames())

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const visible = ref(false)
const selectTypeName = ref()
const addNewNodeTypeName = ref(false)
const newNodeTypeName = ref('')

const open = () => {
  visible.value = true
}

defineExpose({
  open
})

const dataAdd = ref({
  name: '',
  businesses: null as null | string[],
  description: ''
})

const resetFields = () => {
  dataAdd.value = {
    name: '',
    businesses: null as null | string[],
    description: ''
  }
}

const handleSubmit = () => {
  const api = $urlAdmin.node.type.add
  $api(api, { body: dataAdd.value }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      emits('refreshTables')
      process.client && $toast().success($t('labels.addSuccess'))
      resetFields()
      closeOverSide()
    }
  })
}

const findBusinesses = async (s: string) => {
  const api = $urlAdmin.business.select

  const res = await $api(api, { uriParams: { KEY: s } })
  const resData: any = res?.data.value
  if (resData.success) {
    return resData.data
  }
  return null
}

const emits = defineEmits(['close', 'refreshTables', 'newBusiness', 'update:show'])

const closeOverSide = () => {
  visible.value = false
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

const handleCreateNewNodeType = () => {
  newNodeTypeName.value = ''
  addNewNodeTypeName.value = true
  if (selectTypeName.value) {
    selectTypeName.value.hide()
  }
}

const createNewNodeType = () => {
  const newName = newNodeTypeName.value
  if (!newName) {
    return
  }
  const checkName = nodeTypeNames.value.map((nodeTypeName) => {
    if (nodeTypeName.value === newName) {
      return true
    }
    return false
  })

  if (checkName.includes(true)) {
    dataAdd.value.name = newName
    addNewNodeTypeName.value = false
    return
  }

  nodeTypeNames.value.push({
    value: newName
  })
  dataAdd.value.name = newName
  addNewNodeTypeName.value = false
  selectTypeName.value.hide()
}
</script>
